<template>
  <div class="double-pane">
    <div class="left-pane" :class="paneState === 0 ? 'full' : ''">
      <slot name="left-pane" @next="onNext"></slot>
    </div>
    <div class="right-pane" :class="paneState === 1 ? 'full' : 'hidden'">
      <div class="back-button-slot w-100 text-center my-2">
        <slot name="back-button"></slot>
      </div>
      <slot name="right-pane"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "double-pane",
  props: ["paneState"],
  methods: {},
};
</script>

<style lang="scss" scoped>
.back-button-slot {
  justify-content: flex-start;
  padding-left: 20px;
  align-items: center;
}
.back-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.double-pane {
  width: 100%;
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 90px;

  .left-pane {
    min-width: 300px;
    width: 20%;
  }

  .right-pane {
    width: 80%;
    // flex: 1;
  }

  .back-button-slot {
    display: none;
  }

  .left-pane,
  .right-pane {
    border-right: 1px solid #ccc;
    overflow-y: auto;

    @media screen and (max-width: 768px) {
      &.full {
        width: 100%;
      }

      &.hidden {
        display: none;
      }

      .back-button-slot {
        display: flex;
      }
    }
  }
}
</style>
